import { projectsPortalProjectSummarySchema } from '@crest/module-projects/contracts/portal-project-summary';
import { platformPortalAccessScopeBundleSchema } from '@crest/platform-contracts/hosts';
import { z } from 'zod';
export const customerPortalProjectAccessLinksCapability = 'customer-portal.project-access-links.v1';
export const customerPortalProjectHostCapability = 'customer-portal.project-host.v1';
export const customerPortalProjectSectionsSlot = 'customer-portal.project.sections';
export const customerPortalProjectNavigationSlot = 'customer-portal.navigation.primary';
export const customerPortalOpaqueTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/);
export const customerPortalLinkIdSchema = z.string().uuid();
export const customerPortalLinkStateSchema = z.enum(['active', 'revoked', 'expired']);
export const customerPortalGrantSchema = z.string().regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+$/);
export const customerPortalProjectAccessLinkSchema = z.strictObject({
    id: customerPortalLinkIdSchema,
    projectId: z.string().uuid(),
    label: z.string().max(120).nullable(),
    state: customerPortalLinkStateSchema,
    grants: z.array(customerPortalGrantSchema).min(1).superRefine((grants, context) => {
        if (!grants.includes('projects.portal-summary.read')) {
            context.addIssue({ code: 'custom', message: 'Every Project link must include the Project summary grant.' });
        }
        if (new Set(grants).size !== grants.length) {
            context.addIssue({ code: 'custom', message: 'Customer Portal grants must be unique.' });
        }
    }),
    accessScopes: z.array(platformPortalAccessScopeBundleSchema).max(50),
    expiresAt: z.string().datetime({ offset: true }),
    revokedAt: z.string().datetime({ offset: true }).nullable(),
    revision: z.number().int().positive(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const customerPortalCreateProjectAccessLinkSchema = z.strictObject({
    projectId: z.string().uuid(),
    label: z.string().trim().min(1).max(120).nullable().default(null),
    expiresAt: z.string().datetime({ offset: true }),
    idempotencyKey: z.string().uuid(),
});
export const customerPortalRevokeProjectAccessLinkSchema = z.strictObject({
    expectedRevision: z.number().int().positive(),
    reason: z.string().trim().min(3).max(500),
    idempotencyKey: z.string().uuid(),
});
export const customerPortalProjectAccessLinkListResponseSchema = z.strictObject({
    data: z.array(customerPortalProjectAccessLinkSchema),
});
export const customerPortalProjectAccessLinkCreatedResponseSchema = z.strictObject({
    data: customerPortalProjectAccessLinkSchema,
    token: customerPortalOpaqueTokenSchema.nullable(),
    urlPath: z.string().startsWith('/p/').nullable(),
    idempotent: z.boolean(),
});
export const customerPortalProjectAccessLinkResponseSchema = z.strictObject({
    data: customerPortalProjectAccessLinkSchema,
    idempotent: z.boolean(),
});
export const customerPortalPublicProjectResponseSchema = z.strictObject({
    tenant: z.strictObject({ displayName: z.string().min(1).max(240) }),
    project: projectsPortalProjectSummarySchema,
    availableModuleIds: z.array(z.string().regex(/^[a-z][a-z0-9-]*$/)),
    grants: z.array(customerPortalGrantSchema).min(1),
    configurationValues: z.record(z.string(), z.unknown()),
});
//# sourceMappingURL=customer-portal-project-access.contract.js.map